define([
    "./sanitizeModule",
    "./sanitizeService"
], function () {
});